import type { FormFieldConfigProps } from '@/viewmodel/shared/form';
import type { TFunction } from 'i18next';

export function getSupportTicketFields(t: TFunction): FormFieldConfigProps[] {
  return [
    {
      fieldName: 'title',
      label: t('support.form.title'),
      placeholder: t('support.form.titlePlaceholder'),
      type: 'text',
    },
    {
      fieldName: 'description',
      label: t('support.form.description'),
      placeholder: t('support.form.descriptionPlaceholder'),
      type: 'textarea',
    },
    {
      fieldName: 'type',
      label: t('support.form.type'),
      placeholder: t('support.form.typePlaceholder'),
      type: 'select',
      options: [
        { value: 'bug', label: t('support.type.bug') },
        { value: 'ux', label: t('support.type.ux') },
        { value: 'performance', label: t('support.type.performance') },
        { value: 'integrations', label: t('support.type.integrations') },
        { value: 'support', label: t('support.type.support') },
      ],
    },
    {
      fieldName: 'urgency',
      label: t('support.form.urgency'),
      placeholder: t('support.form.urgencyPlaceholder'),
      type: 'select',
      options: [
        { value: 'high', label: t('support.urgency.high') },
        { value: 'medium', label: t('support.urgency.medium') },
        { value: 'low', label: t('support.urgency.low') },
      ],
    },
    {
      fieldName: 'area',
      label: t('support.form.area'),
      placeholder: t('support.form.areaPlaceholder'),
      type: 'text',
    },
  ];
}
